import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 18.4286H9V13.4286C9 13.1453 9.09583 12.9078 9.2875 12.7161C9.47917 12.5244 9.71667 12.4286 10 12.4286H14C14.2833 12.4286 14.5208 12.5244 14.7125 12.7161C14.9042 12.9078 15 13.1453 15 13.4286V18.4286H18V9.42859L12 4.92859L6 9.42859V18.4286ZM4 18.4286V9.42859C4 9.11192 4.07083 8.81192 4.2125 8.52859C4.35417 8.24526 4.55 8.01192 4.8 7.82859L10.8 3.32859C11.15 3.06192 11.55 2.92859 12 2.92859C12.45 2.92859 12.85 3.06192 13.2 3.32859L19.2 7.82859C19.45 8.01192 19.6458 8.24526 19.7875 8.52859C19.9292 8.81192 20 9.11192 20 9.42859V18.4286C20 18.9786 19.8042 19.4494 19.4125 19.8411C19.0208 20.2328 18.55 20.4286 18 20.4286H14C13.7167 20.4286 13.4792 20.3328 13.2875 20.1411C13.0958 19.9494 13 19.7119 13 19.4286V14.4286H11V19.4286C11 19.7119 10.9042 19.9494 10.7125 20.1411C10.5208 20.3328 10.2833 20.4286 10 20.4286H6C5.45 20.4286 4.97917 20.2328 4.5875 19.8411C4.19583 19.4494 4 18.9786 4 18.4286Z",
		fill: "currentColor"
	})
});
export default SvgHome;
